import { SideButton } from '../components/SideButton';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { daycareExitSequence, daycareReturnSequence } from './daycare.sequence';
import { Feature } from 'src/replicant/analytics';
import { animate } from '@play-co/timestep-core/ui';
import { animDuration, createWaiterInView } from 'src/lib/utils';
import StateObserver, { user } from 'src/StateObserver';
import { formatDuration } from 'src/lib/formatDuration';
import { duration } from 'src/replicant/utils/duration';
import { getDaycareId } from '../../replicant/daycare/daycare.getters';

export class DaycareSideButton extends SideButton {
  private waiter = createWaiterInView(this);

  constructor() {
    super({
      width: 183,
      height: 192,
      type: 'daycare',
      label: '',
      visible: false,
      opacity: 0,
      icon: {
        image: 'assets/ui/daycare/icons/daycare_home.png',
        width: 183,
        height: 182,
        offsetY: -18,
      },
      centerOnOrigin: false,
      tracking: {
        feature: Feature.DAYCARE._,
        $subFeature: Feature.DAYCARE.HOME_BUTTON,
      },
    });
  }

  public async onClick() {
    if (await openPopupPromise('popupExitDaycare', { origin: 'hud' })) {
      this.waiter.clear();

      const daycareId = getDaycareId();
      await Promise.all([this.fadeOut(), daycareExitSequence(daycareId)]);
    }
  }

  public updateCountdownTimer(expiresAt: number) {
    let timeRemaining = expiresAt - StateObserver.now();
    if (timeRemaining < 0) {
      void daycareReturnSequence();
      void this.fadeOut();
      return;
    }

    this.updateOpts({ label: formatDuration(timeRemaining) });

    this.waiter.wait(
      () => this.updateCountdownTimer(expiresAt),
      duration({ seconds: 1 }),
    );
  }

  public async fadeIn() {
    this.show();
    await animate(this).now({ opacity: 1 }, animDuration).toPromise();
  }

  public async fadeOut() {
    await animate(this)
      .now({ opacity: 0 }, animDuration)
      .then(() => this.hide())
      .toPromise();
  }
}
